import { Observable } from "rxjs";
import { DynamicRow } from "./dynamic-row.model";

export class DynamicRowTemplate<T> extends DynamicRow<T>{

    property!: string;
    
    dataObserver?: Observable<T>;
    toType: 'generic' | 'item' | 'object' | 'template' | 'tabview' | 'switch';

    constructor(source: Partial<DynamicRowTemplate<T>>) {
        super(source);
        this.type = "template";
        this.toType = "item";
        Object.assign(this, source);
    }
}